import {createStore} from "vuex";

import * as facets from './facets';
import * as viewer from './viewer';

const store = createStore({
    modules: {
        search: {
            namespaced: true,
            ...facets
        },

        viewer: {
            namespaced: true,
            ...viewer
        }
    }
})


export {store}

